import AccountingMemberSettings from '../dto/AccountingMemberSettings.js';
import Error from '../model/Error.js';
import axios from 'axios';

export default class MemberSettingsRepository {
    static findByMember(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/settings`)
                .then((response) => resolve(AccountingMemberSettings.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
